module.exports = __webpack_public_path__ + "img/tower.db1bbe73.png";